export default {"src":"/_next/static/media/TreeOne.5eb5ae87.svg","height":168,"width":122,"blurWidth":0,"blurHeight":0};